<div class="container module-content content-box">
  <!-- Start Activity 7 -->
  <div id="activity1">
      <h2>Activity: Moving On Quiz </h2>
      <div class="radio wrapper">
          <!-- 1 -->
          <div class="question1">
              <br> <b> Landlords can return security deposits at their convenience.</b> <br>
              <input id="question1_1" name="question1" type="radio" [value]="true" [(ngModel)]="model7.model7_Q1" (click)="m7_Q1()"> <label for="question1_1">True</label><br/>
              <input id="question1_2" name="question1" type="radio" [value]="false" [(ngModel)]="model7.model7_Q1" (click)="m7_Q1()"> <label for="question1_2">False</label><br/>
              <div *ngIf="model7.model7_Q1 && model7_Q1" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;Nebraska requires it must be returned within 14 days of lease termination
              </div>
              <div *ngIf="!model7.model7_Q1  && model7_Q1" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 2 -->
          <div class="question2">
              <br> <b>Landlords are allowed to deduct for normal wear on carpet when a tenant moves out</b> <br>
              <input id="question2_1" name="question2" type="radio" [value]="true" [(ngModel)]="model7.model7_Q2" (click)="m7_Q2()"> <label for="question2_1">True</label><br/>
              <input id="question2_2" name="question2" type="radio" [value]="false" [(ngModel)]="model7.model7_Q2" (click)="m7_Q2()"> <label for="question2_2">False</label><br/>
              <div *ngIf="model7.model7_Q2 && model7_Q2" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;Landlords are not supposed to deduct charges for normal wear and tear to a unit.
              </div>
              <div *ngIf="!model7.model7_Q2  && model7_Q2" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 3 -->
          <div class="question3">
              <br> <b> If you move out early, the security deposit serves as the last month's rent.</b> <br>
              <input id="question3_1" name="question3" type="radio" [value]="true" [(ngModel)]="model7.model7_Q3" (click)="m7_Q3()"> <label for="question3_1">True</label><br/>
              <input id="question3_2" name="question3" type="radio" [value]="false" [(ngModel)]="model7.model7_Q3" (click)="m7_Q3()"> <label for="question3_2">False</label><br/>
              <div *ngIf="model7.model7_Q3 && model7_Q3" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;Tenants cannot use the security deposit to cover rent.
              </div>
              <div *ngIf="!model7.model7_Q3  && model7_Q3" style="background-color: rgba(0, 128, 0, 0.25); font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 4 -->
          <div class="question4">
              <br> <b>Leases automatically end unless the landlord gives notice of intent to renew.</b> <br>
              <input id="question4_1" name="question4" type="radio" [value]="true" [(ngModel)]="model7.model7_Q4" (click)="m7_Q4()"> <label for="question4_1">True</label><br/>
              <input id="question4_2" name="question4" type="radio" [value]="false" [(ngModel)]="model7.model7_Q4" (click)="m7_Q4()"> <label for="question4_2">False</label><br/>
              <div *ngIf="model7.model7_Q4 && model7_Q4" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;In Nebraska, at the end of a lease period when there is no intent to renew or evict, leases convert into a month-to-month lease.
              </div>
              <div *ngIf="!model7.model7_Q4  && model7_Q4" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 5 -->
          <div class="question5">
              <br> <b> Tenants must leave the unit clean.</b> <br>
              <input id="question5_1" name="question5" type="radio" [value]="false" [(ngModel)]="model7.model7_Q5" (click)="m7_Q5()"> <label for="question5_1">True</label><br/>
              <input id="question5_2" name="question5" type="radio" [value]="true" [(ngModel)]="model7.model7_Q5" (click)="m7_Q5()"> <label for="question5_2">False</label><br/>
              <div *ngIf="model7.model7_Q5 && model7_Q5" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;The unit should be clean when you move in and when you move out.
              </div>
              <div *ngIf="!model7.model7_Q5  && model7_Q5" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 6 -->
          <div class="question6">
              <br> <b> Tenants cannot be evicted during the winter. </b> <br>
              <input id="question6_1" name="question6" type="radio" [value]="true" [(ngModel)]="model7.model7_Q6" (click)="m7_Q6()"> <label for="question6_1">True</label><br/>
              <input id="question6_2" name="question6" type="radio" [value]="false" [(ngModel)]="model7.model7_Q6" (click)="m7_Q6()"> <label for="question6_2">False</label><br/>
              <div *ngIf="model7.model7_Q6 && model7_Q6" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;Weather does not affect evictions. However, with utilities it may be a factor.
              </div>
              <div *ngIf="!model7.model7_Q6  && model7_Q6" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>

          <!-- 7 -->
          <div class="question7">
              <br> <b> All tenants have a lease agreement whether verbal or in writing.</b> <br>
              <input id="question7_1" name="question7" type="radio" [value]="true" [(ngModel)]="model7.model7_Q7" (click)="m7_Q7()"> <label for="question7_1">True</label><br/>
              <input id="question7_2" name="question7" type="radio" [value]="false" [(ngModel)]="model7.model7_Q7" (click)="m7_Q7()"> <label for="question7_2">False</label><br/>
              <div *ngIf="model7.model7_Q7 && model7_Q7" style="background-color: rgba(255,0,0,0.25);font-weight: bolder;">
                  &nbsp;All tenants have a contract called a lease agreement. It may be written or oral. Written is recommended.
              </div>
              <div *ngIf="!model7.model7_Q7  && model7_Q7" style="background-color: rgba(0, 128, 0, 0.25);font-weight: bolder;">
                  &nbsp;Correct!
              </div>
          </div>
      </div>
      <div *ngIf="flag" style="color:red" class="warning">
          You must answer all questions correctly before moving on
      </div>
  </div>
</div>

<div class="container navigate-buttons">
  <button type="button" class="btn waves-dark w-25" (click)="goBack($event)"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
  <button *ngIf="previewByAdmin || !delay || activityOneCorrect()" type="button" class="btn waves-dark w-25" (click)="goNext($event) && resetFlag()">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
  <button *ngIf="!(previewByAdmin || !delay || activityOneCorrect())" type="button" class="btn waves-dark w-25" (click)="setFlag()" style="background-color: #ffd782;">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
</div>
